module.exports = __webpack_public_path__ + "static/media/gritp.f79044d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gritp.jpg
// module id = 73
// module chunks = 2